<template>
  <div v-if="load" style="position: relative">
    <div class="row mb-4">
      <div class="col-md-6">
        <input class="input form-control" placeholder="Pesquisar por título ou conteúdo">
        <search-icon class="icon icon-within"/>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
      <div class="col-md-4">
        <div class="skeleton"></div>
      </div>
    </div>

  </div>

  <div v-else style="position: relative">

    <div class="row mb-2">
      <div class="col-md-6">
        <input v-model="query.generic" class="input form-control"
               @keypress.enter="find()"
               placeholder="Pesquisar por título ou conteúdo">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">

        <table class="table table-borderless table-border table-align table-h51">
          <thead>
            <tr>
              <th>Título</th>
              <th>Conteúdo</th>
              <th>Criado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="notification in notifications" :key="notification.id">
              <td>{{ notification.title }}</td>
              <td class="notification-html" v-html="notification.content"/>
              <td>{{ notification.createdAt | datetime }}</td>
              <td class="text-right">
                <button v-if="hasMarkdownDetail(notification)" class="btn btn-outline btn-sm px-3 mr-2" @click="openDetail(notification)" title="Mostrar detalhes">
                  <EyeIcon size="1.5x"/>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
      </div>

      </div>
    </div>

    <Loading :load="false" message="Carregando notificações.."/>

    <Modal v-model="showDetail" width="lg">
      <template #header>{{ selected.title }}</template>
      <div class="detail-section">
        <MarkdownView :source="detailContent"/>
      </div>
      <p class="detail-section">
        <CalendarIcon class="mr-2" size="1x"/> Criado em {{ selected.createdAt | datetime }}
      </p>
      <template #footer>
        <button class="btn btn-outline mr-2" @click="showDetail = false">Fechar</button>
        <button class="btn btn-primary" @click="downloadDetail">Baixar detalhes</button>
      </template>
    </Modal>
  </div>

</template>

<script>
  import Loading from '@/components/shares/Loading'
  import MarkdownView from '@/components/shares/MarkdownView'
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { CalendarIcon, EyeIcon, SearchIcon } from 'vue-feather-icons'

  export default {
    components: { CalendarIcon, EyeIcon, Loading, MarkdownView, Modal, Pagination, SearchIcon },
    computed: {
      detailContent() {
        return this.hasMarkdownDetail(this.selected) ? this.selected.detail.content : ''
      },
      notifications() {
        return this.getModels || []
      }
    },
    created() {
      this.addOrderBy('CreatedAt')
      this.find()
    },
    data() {
      return {
        load: false,
        nameModel: 'Notification',
        selected: {},
        showDetail: false
      }
    },
    methods: {
      closeLoad() {
        this.load = false
      },
      downloadDetail() {
        const blob = new Blob([this.detailContent], { type: 'text/markdown' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${this.selected.title || 'detalhes'}.md`
        link.click()
        URL.revokeObjectURL(url)
      },
      find() {
        this.asyncTemplateSelect()
      },
      hasMarkdownDetail(notification) {
        const detail = notification && notification.detail
        return !!detail && detail.format === 'markdown' && !!detail.content
      },
      openDetail(notification) {
        this.selected = notification
        this.showDetail = true
      },
      openLoad() {
        this.load = true
      }
    },
    mixins: [ModelMapper],
    name: 'Notifications'
  }
</script>

<style scoped>

/* O HTML da campanha traz cor e fundo inline pensados para o popup/e-mail
   (texto branco, cinza claro, roxo). Aqui eles sao anulados para o texto seguir
   a cor do tema, claro ou escuro, e aparecer por completo na tabela. #85216 */
.notification-html {
  color: var(--primary-text-color);
  overflow-wrap: anywhere;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.notification-html ::v-deep * {
  color: inherit !important;
  background: transparent !important;
}

.notification-html ::v-deep a {
  color: var(--primary-color) !important;
  text-decoration: underline;
}

.notification-html ::v-deep a:hover {
  color: var(--primary-color-hover) !important;
}

.notification-html ::v-deep img {
  max-width: 100%;
  height: auto;
}

.detail-icon {
  cursor: pointer;
  color: var(--primary-color, #1976d2);
  transition: opacity 0.2s ease-in-out;
}

.detail-icon:hover {
  opacity: 0.7;
}

.detail-section {
  margin-top: 1rem;
  padding: 1rem 1.25rem;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  max-height: 60vh;
  overflow-y: auto;
}

.skeleton {
  background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%);
  background-size: 1300px;
  animation: gradient 1.7s ease infinite;
  border-radius: 3px;
  height: 30px;
  animation-duration: 1.7s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: gradient;

}

@keyframes gradient {
  0% {
    background-position: -650px 0;
  }
  100% {
    background-position: 650px 0;
  }
}

</style>
